import axios from 'axios'
import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'

// Function to determine the domain based on the current URL
// https://tranquilla-ai-dev.mresult.com/
const getDomain = () => {
  const url = window.location.href
  if (url.includes('localhost')) {
    /// TODO Change back to localhost : IF FORGOTTEN CHANGE IT BACK PLEASE
    return 'http://localhost:8001/'
  } else if (url.includes('tranquilla.nearlyhuman.ai')) {
    return 'https://tranquilla-ai.nearlyhuman.ai/'
  } else if (url.includes('https://tranquilla.mresult.com/')) {
    return 'https://tranquilla-ai.mresult.com/'
  } else if (url.includes('https://tranquilla-dev.mresult.com/')) {
    return 'https://tranquilla-ai-dev.mresult.com/'
  } else if (url.includes('https://tranquilla-dev.nearlyhuman.ai/')) {
    return 'https://tranquilla-ai-dev.nearlyhuman.ai/'
  }
  return 'https://tranquilla-ai-dev.mresult.com/' // Default domain
}

// Get the dynamic domain
const domain = getDomain()

export const fetchEULAandPrivacyPolicy = async () => {
  const res = await fetch(`${getDomain()}legal-document/latest`)
  if (!res.ok) throw new Error('Failed to fetch policies')
  const data = await res.json()
  console.log(data)
  return data
}

export const acceptTOS = async (payload) => {
  try {
    const res = await fetch(`${getDomain()}accept-tos`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
    return res
  } catch (err) {
    console.error('Error accepting TOS:', err)
  }

  console.log('TOS accepted successfully')
}

export const checkIfPoliciesAccepted = async (user) => {
  const res = await fetch(`${getDomain()}user/${user}/latest-tos-acceptance`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
  if (res.status === 404) {
    // User has never accepted TOS
    return null
  }
  if (!res.ok) {
    throw new Error(`Failed to check TOS acceptance: ${res.status}`)
  }
  const data = await res.json()
  return data
}

// Function to create axios instance with dynamic baseURL
const createApiInstance = (baseURL) => {
  return axios.create({
    baseURL: baseURL,
  })
}

// Axios API calls
export const getData = async (endpoint) => {
  const api = createApiInstance(sessionStorage.getItem('baseURL') || domain)
  try {
    const response = await api.get(endpoint)
    return response.data
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error
  }
}

export const postData = async (endpoint, data, headers = {}) => {
  const api = createApiInstance(sessionStorage.getItem('baseURL') || domain)
  try {
    const response = await api.post(endpoint, data, { headers })
    console.log(response)
    if (endpoint === '/sign-up') {
      return response
    }
    return response.data
  } catch (error) {
    console.error('Error posting data:', error)
    throw error
  }
}

export const putData = async (endpoint, data) => {
  const api = createApiInstance(sessionStorage.getItem('baseURL') || domain)
  try {
    const response = await api.put(endpoint, data)
    return response.data
  } catch (error) {
    console.error('Error posting data:', error)
    throw error
  }
}

export const deleteData = async (endpoint, data) => {
  const api = createApiInstance(sessionStorage.getItem('baseURL') || domain)
  try {
    const response = await api.delete(endpoint, data)
    return response.data
  } catch (error) {
    console.error('Error posting data:', error)
    throw error
  }
}

// Hook to manage query parameter changes for dynamic baseURL
export const useQueryParamHandler = () => {
  const location = useLocation()

  useEffect(() => {
    const queryString = location.search
    const queryParams = new URLSearchParams(queryString)

    const agentNameParam = queryParams.get('agentName')

    console.log(agentNameParam)

    if (agentNameParam !== null) {
      const BASE_URL = `${domain}${agentNameParam}/`
      sessionStorage.setItem('baseURL', BASE_URL)
      sessionStorage.setItem('userType', 'user')
      sessionStorage.setItem('agentName', agentNameParam)
    } else {
      sessionStorage.setItem('baseURL', domain)
      sessionStorage.setItem('userType', 'admin')
      sessionStorage.removeItem('agentName')
    }
  }, [location]) // Dependency on location so it re-runs whenever the URL changes
}
